import apiClient from "./api"; // On utilise le client API configuré

// Fonction d'API pour la génération du rapport
export const generateAllTransactionReport = async (accountId, domainId) => {
  try {
    const response = await apiClient.post(
      `/api/Transactions/generate-All-report/${accountId}/${domainId}`,
      null,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 404) {
        throw new Error(error.response.data?.message || "Aucune transaction trouvée pour ce Client.");
      }
      throw new Error(error.response.data?.message || "Une erreur est survenue lors de la génération du rapport.");
    }
    throw new Error("Impossible de contacter le serveur.");
  }
};
